import { styled } from '@mui/material'
import { COLORS } from 'src/styles/common'

export const TopDivider = styled('div')<{ bgColor?: string }>`
  width: 100%;
  height: 15px;
  background-color: ${(props) => props?.bgColor || COLORS.PRIMARY};
`
